"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

exports.styles = function (_a) {
  var sizeAvatarS = _a.sizeAvatarS,
      x2 = _a.x2,
      colorTextSecondary = _a.colorTextSecondary,
      toneValueOverlay = _a.toneValueOverlay;
  return {
    contact: {
      display: 'flex',
      alignItems: 'center'
    },
    contactAvatar: {
      position: 'relative',
      marginRight: x2,
      width: sizeAvatarS + "px",
      height: sizeAvatarS + "px"
    },
    contactDetails: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    },
    overlay: {
      position: 'absolute',
      top: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      borderRadius: '100%',
      backgroundColor: colorTextSecondary.normal,
      opacity: toneValueOverlay
    }
  };
};